import builder from '../builder';
import ConsoleLamp from '../../streamline-icons/bold/console-lamp.svg';

export default builder('IconConsoleLampBold', ConsoleLamp);
